import * as Sentry from '@sentry/browser'
// TODO get appRoutes from provider
import { apiRoutes } from '../'

/* ---------------------------------------------------- */

  const handleResponse = response => {
    if(!response.ok) throw new Error(response.status)

    return response.json()
  }
  const handleErrors = error => {
    Sentry.captureException(error)
  }
  const handleHeaders = method => {
    return {
      method,
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
  };

/* ---------------------------------------------------- */

  export const apiToInstall = {

  }

/* ---------------------------------------------------- */

  export const API = {
    get(name) {
      return fetch(apiRoutes[name], handleHeaders('GET'))
        .then(handleResponse)
        .catch(handleErrors)
    },
    put(name, data) {
      return fetch(apiRoutes[name], {
        ...handleHeaders('PUT'),
        body: JSON.stringify(data),
      })
        .then(handleResponse)
        .catch(handleErrors)
    }
  }

/* ---------------------------------------------------- */
